import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import { useLoading } from '../../../commons/Loading';
import { useAuth } from '../../../commons/Auth';
import { NumberParam, useQueryParams, withDefault } from 'use-query-params';
import { deleteFile, getSignedUrl } from '../../../lib/fetch/files';
import {
  getArchiveFiles,
  uploadArchiveFile,
} from '../../../lib/fetch/profiles';
import { Col, CustomInput, FormGroup, Row } from 'reactstrap';
import { ContPaginationPage } from '../../../styled-components';
import {
  BooleanField,
  DataTable,
  DateTimeField,
  Field,
} from '../../../commons/DataTable';
import ActionsField from './ActionsField';
import generatePaginationOptions from '../../../lib/helpers/generatePaginationOptions';
import { withRouter } from 'react-router-dom';
import AddFileButton from './AddFileButton';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const Archive = ({}) => {
  const [t] = useTranslation();
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();
  const [{ newToken } = {}] = useAuth();

  const [documents, setDocuments] = useState([]);
  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
  });

  function onFilter(queryDiff) {
    if (queryDiff.limit && queryDiff.limit !== limit) {
      queryDiff.offset = 0;
    }
    setQuery(queryDiff);
  }

  const { limit, offset } = query;

  async function handleFileListView(key) {
    showLoading();

    const { data, error } = await getSignedUrl(key, newToken);

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    hideLoading();
    window.open(data.url, '_blank');
  }

  async function getArchiveDocuments() {
    showLoading();

    const { data, error, headers = {} } = await getArchiveFiles({
      limit,
      offset,
      newToken,
    });

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    setDocuments(data.documents);
    setTotal(+headers['x-total-count']);
    hideLoading();
  }

  async function uploadFile(file, toggleAddNewFileModal) {
    showLoading();

    const { error, data } = await uploadArchiveFile({
      data: file,
      newToken,
    });

    if (error) {
      hideLoading();

      toggleAddNewFileModal();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    hideLoading();
    toggleAddNewFileModal();
    getArchiveDocuments();
    alert.success(t('COMMON:SUCCESS_UPLOAD'));
  }

  async function handleDelete({ documentId }) {
    showLoading();

    const { error, data } = await deleteFile({
      documentId,
      newToken,
    });

    if (error) {
      hideLoading();

      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    getArchiveDocuments();
    alert.success(t('COMMON:SUCCESS_DELETE'));
  }

  useEffect(() => {
    getArchiveDocuments();
  }, [limit, offset]);

  return (
    <>
      <Row className="align-items-center">
        <Col xs={12} style={{ marginBottom: 20, textAlign: 'end' }}>
          <AddFileButton uploadFile={uploadFile} />
        </Col>
      </Row>

      <DataTable
        data={documents}
        total={total}
        offset={offset}
        limit={limit}
        onFilter={onFilter}
        emptyText={t('COMMON:NO_DATA')}
      >
        <Field title="Nome" source="file.name" className="text-left" />
        <Field title="Tipologia" source="type.name" className="text-left" />
        <DateTimeField
          title="Data Caricamento"
          source="file.createdAt"
          format="DD/MM/YYYY"
        />
        <Field title="Caricato da" source="uploadedBy" />
        <ActionsField
          title="Azioni"
          handleFileListView={handleFileListView}
          deleteFileConfirm={handleDelete}
        />
      </DataTable>

      <ContPaginationPage>
        <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

        <FormGroup>
          <CustomInput
            type="select"
            className="pagination-select"
            id="perPage"
            name="perPage"
            value={query.limit}
            onChange={({ target: { value: limit } }) => {
              onFilter({ limit });
            }}
          >
            {generatePaginationOptions()}
          </CustomInput>
        </FormGroup>
      </ContPaginationPage>
    </>
  );
};

export default Archive;
